/** 5MB — matches profile-images / instructor-images bucket limits */
export const IMAGE_UPLOAD_MAX_BYTES = 5 * 1024 * 1024;

export const IMAGE_UPLOAD_ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const IMAGE_UPLOAD_ACCEPT = 'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp';

export const BUCKET_EVENT_IMAGES = 'event-images';

/**
 * Client-side validation before image upload (jpg/png/webp, max 5MB).
 * @param {File | null | undefined} file
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateImageFile(file) {
  if (!file) {
    return { valid: false, message: 'No file selected.' };
  }
  if (!IMAGE_UPLOAD_ALLOWED_TYPES.includes(file.type)) {
    return { valid: false, message: 'Only JPG, PNG, and WebP images are allowed.' };
  }
  if (file.size > IMAGE_UPLOAD_MAX_BYTES) {
    return { valid: false, message: 'Image must be 5MB or smaller.' };
  }
  return { valid: true };
}

/**
 * Convert a storage path to a public URL for display.
 * Handles both relative paths (from DB) and full URLs (legacy/external).
 *
 * @param {string | null | undefined} path - Storage path or full URL
 * @param {string} [bucket='profile-images'] - Supabase storage bucket name
 * @returns {string | null} Full public URL or null if no path
 */
export function getPublicImageUrl(path, bucket = 'profile-images') {
  if (!path) return null;

  // If already a full URL, return as-is
  if (path.startsWith('http')) return path;

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) return null;

  return `${supabaseUrl}/storage/v1/object/public/${bucket}/${path}`;
}
